import { useState, useEffect } from 'react'
import { QueryListFilter } from '@feedyou-ai/feedbot-schema'

import { QueryKey, QueryValue } from './types'
import { useStableObject } from '../../../lib/object/useStableObject'

export function useFilter(givenFilter: QueryListFilter = {}) {
  const givenFilterStable = useStableObject(givenFilter)
  const [filter, setFilter] = useState<QueryListFilter>({})
  useEffect(() => setFilter(givenFilterStable), [givenFilterStable, setFilter])

  return {
    filter,
    setFilterValue: (key: QueryKey, value: QueryValue) =>
      setFilter(prev => ({ ...prev, [key]: value }))
  }
}
